export const tagArray = [
  { id: 1, category: 1, name: 'BBQ' },
  { id: 2, category: 1, name: 'African' },
  { id: 3, category: 1, name: 'Beef' },
  { id: 4, category: 1, name: 'Chinese' },
  { id: 5, category: 1, name: 'Chicken' },
  { id: 6, category: 1, name: 'French' },
  { id: 7, category: 1, name: 'Fish' },
  { id: 8, category: 1, name: 'Indian' },
  { id: 9, category: 1, name: 'Gluten free' },
  { id: 10, category: 1, name: 'Italian' },
  { id: 11, category: 1, name: 'Lamb' },
  { id: 12, category: 1, name: 'Japanese' },
  { id: 13, category: 3, name: 'Deep Dish' },
  { id: 14, category: 3, name: 'Detroit Style' },
  { id: 15, category: 3, name: 'Margherita' },
  { id: 16, category: 3, name: 'Gluten Free' },
  { id: 17, category: 3, name: 'Vegan' },
  { id: 18, category: 7, name: 'Eggs' },
  { id: 19, category: 7, name: 'Pancakes' },
  { id: 20, category: 7, name: 'Meat' },
  { id: 21, category: 7, name: 'Bread' },
  { id: 22, category: 7, name: 'Gluten Free' },
  { id: 23, category: 7, name: 'Vegan' },
  { id: 24, category: 6, name: 'Cakes' },
  { id: 25, category: 6, name: 'Pies' },
  { id: 26, category: 6, name: 'Pastries' },
  { id: 27, category: 6, name: 'Creamy Things' },
  { id: 28, category: 6, name: 'Gluten Free' },
  { id: 29, category: 6, name: 'Vegan' },
  { id: 30, category: 2, name: 'Cook Medium Rare' },
  { id: 31, category: 2, name: 'Plant Based' },
  { id: 32, category: 2, name: 'Gluten Free' },
  { id: 33, category: 2, name: 'Vegan' },
  { id: 34, category: 4, name: 'Meat' },
  { id: 35, category: 4, name: 'Seafood' },
  { id: 36, category: 4, name: 'Vegetable' },
  { id: 37, category: 4, name: 'Gluten Free' },
  { id: 38, category: 4, name: 'Vegan' },
  { id: 39, category: 5, name: 'Soup' },
  { id: 40, category: 5, name: 'Vegetable' },
  { id: 41, category: 5, name: 'Salad' },
  { id: 42, category: 5, name: 'Gluten Free' },
  { id: 43, category: 5, name: 'Vegan' },
  { id: 44, category: 13, name: 'Meat' },
  { id: 45, category: 13, name: 'Portuguese' },
  { id: 47, category: 13, name: 'BBQ' },
  { id: 48, category: 13, name: 'Gluten Free' },
  { id: 49, category: 13, name: 'Vegan' },
  { id: 50, category: 1, name: 'Pasta' },
  { id: 51, category: 1, name: 'korean' },
  { id: 52, category: 1, name: 'Pork' },
  { id: 53, category: 1, name: 'Mexican' },
  { id: 54, category: 1, name: 'Shellfish' },
  { id: 55, category: 1, name: 'portuguese' },
  { id: 56, category: 1, name: 'veal' },
  { id: 57, category: 1, name: 'Russian' },
  { id: 58, category: 1, name: 'vegetarian' },
  { id: 59, category: 1, name: 'south american' },
  { id: 60, category: 1, name: 'vegan' },
  { id: 61, category: 1, name: 'spanish' },
  { id: 62, category: 1, name: 'Thai' },
  { id: 63, category: 1, name: 'Vietnamese' },
  { id: 66, category: 13, name: 'AREPA' },
  { id: 67, category: 13, name: 'BURRITO' },
  { id: 68, category: 13, name: 'EMPENADA' },
  { id: 69, category: 13, name: 'GRILLED' },
  { id: 70, category: 13, name: 'HAND PIE' },
  { id: 71, category: 13, name: 'ON-A-STICK' },
  { id: 72, category: 13, name: 'PANINI' },
  { id: 73, category: 13, name: 'PAPUSA' },
  { id: 74, category: 13, name: 'PRETZEL' },
  { id: 75, category: 13, name: 'SANDWICH' },
  { id: 76, category: 13, name: 'SUB/HOAGIE' },
  { id: 77, category: 13, name: 'TACO' },
  { id: 78, category: 13, name: 'TOAST' },
  { id: 79, category: 13, name: 'WRAPS' },
  { id: 80, category: 6, name: 'Doughnut' },
  { id: 82, category: 1, name: 'Other Fowl' },
  { id: 84, category: 1, name: 'LOW SODIUM' },
  { id: 85, category: 2, name: 'LOW SODIUM' },
  { id: 86, category: 3, name: 'LOW SODIUM' },
  { id: 87, category: 4, name: 'LOW SODIUM' },
  { id: 88, category: 5, name: 'LOW SODIUM' },
  { id: 89, category: 6, name: 'LOW SODIUM' },
  { id: 90, category: 7, name: 'LOW SODIUM' },
  { id: 91, category: 13, name: 'LOW SODIUM' },
  { id: 92, category: 14, name: 'Arby’s' },
  { id: 93, category: 14, name: 'Bojangles' },
  { id: 94, category: 14, name: 'Burger King' },
  { id: 95, category: 14, name: 'Checkers/Rally’s' },
  { id: 96, category: 14, name: 'Chick-fil-A' },
  { id: 97, category: 14, name: 'Chipotle' },
  { id: 98, category: 14, name: 'Church’s' },
  { id: 99, category: 14, name: 'Del Taco' },
  { id: 100, category: 14, name: 'Domino’s' },
  { id: 101, category: 14, name: 'Dunkin’' },
  { id: 102, category: 14, name: 'El Pollo Loco' },
  { id: 103, category: 14, name: 'Freddy’s' },
  { id: 104, category: 14, name: 'In-N-Out' },
  { id: 105, category: 14, name: 'Hardee’s' },
  { id: 106, category: 14, name: 'Hunt Brothers' },
  { id: 107, category: 14, name: 'Jack in the Box' },
  { id: 108, category: 14, name: 'Jimmy John’s' },
  { id: 109, category: 14, name: 'KFC' },
  { id: 110, category: 14, name: 'McDonalds' },
  { id: 111, category: 14, name: 'Pizza Hut' },
  { id: 112, category: 14, name: 'Popeye’s' },
  { id: 113, category: 14, name: 'Raising Cane’s' },
  { id: 114, category: 14, name: 'Shake Shack' },
  { id: 115, category: 14, name: 'Sonic' },
  { id: 116, category: 14, name: 'Subway' },
  { id: 117, category: 14, name: 'Taco Bell' },
  { id: 118, category: 14, name: 'Taco John’s' },
  { id: 119, category: 14, name: 'Wendy’s' },
  { id: 120, category: 14, name: 'Whataburger' },
  { id: 121, category: 14, name: 'Wingstop' },
  { id: 122, category: 14, name: 'Zaxby’s' },
  { id: 123, category: 14, name: 'BBQ' },
  { id: 124, category: 14, name: 'Beef' },
  { id: 125, category: 14, name: 'Bowls' },
  { id: 126, category: 14, name: 'Breakfast' },
  { id: 127, category: 14, name: 'Burgers' },
  { id: 128, category: 14, name: 'Burrito' },
  { id: 129, category: 14, name: 'Cheese' },
  { id: 130, category: 14, name: 'Chicken' },
  { id: 131, category: 14, name: 'Croissant' },
  { id: 132, category: 14, name: 'English Muffin' },
  { id: 133, category: 14, name: 'Fries' },
  { id: 134, category: 14, name: 'Grilled' },
  { id: 135, category: 14, name: 'Gluten Free' },
  { id: 136, category: 14, name: 'Hash Browns' },
  { id: 137, category: 14, name: 'Hot Dogs' },
  { id: 138, category: 14, name: 'Mexican' },
  { id: 139, category: 14, name: 'Nachos' },
  { id: 140, category: 14, name: 'Pizza' },
  { id: 141, category: 14, name: 'Pork' },
  { id: 142, category: 14, name: 'Potato' },
  { id: 143, category: 14, name: 'Salad' },
  { id: 144, category: 14, name: 'Sandwich' },
  { id: 145, category: 14, name: 'Sausage' },
  { id: 146, category: 14, name: 'Shakes' },
  { id: 147, category: 14, name: 'Sweets' },
  { id: 148, category: 14, name: 'Tacos' },
  { id: 149, category: 14, name: 'Veggie' },
  { id: 150, category: 14, name: 'Wraps' },
  { id: 151, category: 14, name: 'Bacon' }
];

const entreeTypeNames = [
  'bbq',
  'beef',
  'chicken',
  'fish',
  'gluten free',
  'lamb',
  'low sodium',
  'other fowl',
  'pasta',
  'pork',
  'shellfish',
  'vegan',
  'vegetarian',
  'veal',
];

const entreeNationalityNames = [
  'african',
  'chinese',
  'french',
  'indian',
  'italian',
  'japanese',
  'korean',
  'mexican',
  'portuguese',
  'russian',
  'south american',
  'spanish',
  'thai',
  'vietnamese',
];

export const normalizeTagName = (name) => name.trim().toLowerCase();

export const sortTagsByName = (a, b) =>
  a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });

export const buildEntreeTagColumns = (tags) => ({
  types: tags
    .filter(tag => entreeTypeNames.includes(normalizeTagName(tag.name)))
    .sort(sortTagsByName),
  nationalities: tags
    .filter(tag => entreeNationalityNames.includes(normalizeTagName(tag.name)))
    .sort(sortTagsByName),
});

export const categoriesArray = [
  { id: 1, name: 'ENTREES' },
  { id: 3, name: 'PIZZA' },
  { id: 2, name: 'BURGERS' },
  { id: 4, name: 'APPETIZERS' },
  { id: 5, name: 'SIDES' },
  { id: 6, name: 'DESSERT' },
  { id: 7, name: 'BREAKFAST' },
  { id: 13, name: 'HANDHELD' },
  { id: 14, name: 'FAST FOOD' },
  { id: 8, name: 'WINE' },
  { id: 9, name: 'MIXED DRINKS' },
  { id: 10, name: 'BEER' },
  { id: 11, name: 'COFFEE' },
  { id: 12, name: 'OTHER DRINKS' }
];